/** Paint an icon action without replacing its button, focus, state or handlers.
 * Accessible names and tooltips use the canonical interface translation owner.
 * Contexts without SVG support retain readable text instead of a blank control. */
export function paintIconAction(ctx, node, name, label, text = '') {
  const translate = ctx.uiText ?? ((value) => value);
  const accessible = translate(label);
  const visible = translate(text);
  const key = JSON.stringify([name, accessible, visible, Boolean(ctx.icon)]);
  if (node.dataset.iconAction === key) return node;
  node.dataset.iconAction = key;
  node.setAttribute('aria-label', accessible);
  node.title = accessible;
  node.dataset.iconOnly = String(Boolean(name && !text && ctx.icon));
  if (name && ctx.icon) {
    node.replaceChildren(ctx.icon(name));
    if (visible) node.append(ctx.e('span', '', visible));
  } else node.textContent = visible || accessible;
  return node;
}
